import { render, staticRenderFns } from "./ScholarshipLevelMinimumSave.vue?vue&type=template&id=672ce006&"
import script from "./ScholarshipLevelMinimumSave.vue?vue&type=script&lang=js&"
export * from "./ScholarshipLevelMinimumSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports